import { render } from "./TelegramDetail.vue?vue&type=template&id=361197ba&lang=pug"
import script from "./TelegramDetail.vue?vue&type=script&lang=js"
export * from "./TelegramDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__